import React from 'react';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import {
  StackedBar,
  StackedBarData,
} from '../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { formatCurrency } from '../../../../../../CommonUtils/formatNumber';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../../../CommonComponents/OPL/Dot/Dot';

interface Props {
  data: StackedBarData;
}

export const NetWorthMakeup: React.FC<Props> = ({ data }) => {
  const isEmpty = data.reduce((acc, { value }) => acc + value, 0) === 0;

  return (
    <>
      {isEmpty ? (
        <Box bg="neutral.300" height={24} borderRadius="medium" />
      ) : (
        <StackedBar
          data={data.map(d => ({ ...d, value: Math.abs(d.value) }))}
          height={24}
          formatter={val => formatCurrency(val)}
        />
      )}

      {!isEmpty && (
        <Box display="flex" alignItems="center" mt="8">
          {data.map(point => (
            <Box key={point.id} display="flex" alignItems="center" mr="16">
              <Dot bg={point.color} mr="4" size={8} />

              <Text fontSize="small" fontWeight={500} color="neutral.600">
                {point.label}
              </Text>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};
